__turbopack_context__.v({
  "ContentInner": "RJgzeW_ContentInner",
  "ReadMoreContainer": "RJgzeW_ReadMoreContainer",
  "Truncated": "RJgzeW_Truncated",
});
